import { connect } from 'react-redux'
import privacyPolicy from './privacyPolicy'
const mapStoreToProps = state => ({
})
const mapDispatchToProps = dispatch => ({
  // applyFilters:(filter_string)=>dispatch(applyFilters(filter_string))
})

export default connect(mapStoreToProps, mapDispatchToProps)(privacyPolicy)